import CancellationPolicySettings from './CancellationPolicySettings';

export default CancellationPolicySettings;
